export default __webpack_public_path__ + "static/media/Vazir-Light.9eec7bb9.woff";